export default () => ({
  path: null,
  direction: 0,
  routesOrder: []
})
